export default __webpack_public_path__ + "static/media/colors-grayMossCharcoal.693c15a7.jpg";